const fromdataedit = [
  {
    inputdata: "",
    title: "医院名称",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "selectautocompleteHB",
    width: "490px",
    disabled: false,
    // lablewith: '90px',
    options: [],
  },
  {
    inputdata: "",
    title: "科室",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请选择",
    types: "",
    inputtype: "select",
    width: "490px",
    options: [],
  },
  {
    inputdata: "",
    title: "产品线",
    fontSize: "14px",
    color: "#333333",
    placeholder: "全部",
    types: "",
    inputtype: "select",
    width: "490px",
    btx: false,
    // lablewith: '490px',
    options: [],
  },
  {
    inputdata: "",
    title: "经销商",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "selectautocompletes",
    width: "490px",
    // lablewith: '90px',
    options: [],
  },
  {
		inputdata: '',
		title: '业务员',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: '',
		inputtype: 'autocompletePer',
		width: '490px',
		// lablewith: '90px',
	},
];
export default fromdataedit;
